<template>
  <v-toolbar color="transparent" class="greytxt--text px-0 elevation-0 breadcrumbs" dense>
    <!-- Go back button -->
    <a v-if="path !== '/'" class="cursor-as-pointer pl-0" tag="button" @click="goBackToPath()">
      <v-btn icon>
        <v-icon color="greytxt">chevron_left</v-icon>
      </v-btn>
    </a>
    <!-- Breadcrumbs -->
    <v-toolbar-title class="mx-0">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-0">
        <template #item="props">
          <a class="white--text caption" @click="openFolder(props.item.path)">{{ props.item.name }}</a>
          <!-- <span v-else class="white--text caption">{{ props.item.name }}</span> -->
        </template>
      </v-breadcrumbs>
    </v-toolbar-title>
  </v-toolbar>
</template>

<script setup>

import { computed } from 'vue';

import { getBreadcrumbs } from '@/utils/content';

// eslint-disable-next-line no-undef
const props = defineProps({
  path: {
    type: String,
    default: ''
  },
  openFolder: { type: Function, default: null }
});

const breadcrumbs = computed(() => getBreadcrumbs(props.path));

const goBackToPath = () => {
  const item = breadcrumbs.value.length > 1 ? breadcrumbs.value.length - 2 : breadcrumbs.value.length - 1;
  props.openFolder(breadcrumbs.value[item].path);
};

</script>

<style scoped>
    .breadcrumbs >>> .v-toolbar__content {
        padding: 0 !important;
    }
</style>
